<template>
    <div class="h-screen w-screen block dark:text-main-text-dark bg-gray-50 dark:bg-gray-500 overflow-auto">
        <NuxtPage />
    </div>
</template>

<script lang="ts" setup>
const config = useRuntimeConfig().public
useHead({
  title: config.appName
})
const { colors } = useRuntimeConfig().public

const store = $store()
const themeColor = store.theme.getColor
const setThemeColor = () => {
  if (process.client && colors[themeColor as keyof typeof colors]) {
    const color = colors[themeColor as keyof typeof colors]
    const r: HTMLElement | null = document.querySelector(':root')
    if (r) {
      r.style.setProperty('--primary-main-50', color['50'])
      r.style.setProperty('--primary-main-100', color['100'])
      r.style.setProperty('--primary-main-200', color['200'])
      r.style.setProperty('--primary-main-300', color['300'])
      r.style.setProperty('--primary-main-400', color['400'])
      r.style.setProperty('--primary-main-500', color['500'])
      r.style.setProperty('--primary-main-600', color['600'])
      r.style.setProperty('--primary-main-700', color['700'])
      r.style.setProperty('--primary-main-800', color['800'])
      r.style.setProperty('--primary-main-900', color['900'])
    }
  }
}

onMounted(() => {
  themeColor !== 'orange' && setThemeColor()
})
</script>
